import React from "react";
import { AuthProvider } from "./AuthContext";
import { LoaderProvider } from "./LoaderContext";
import { CartProvider } from "./CartContext";
import { CouponProvider } from "./CouponContext";
import { WalletProvider } from "./WalletContext";
import { GraffitiProvider } from "./GraffitiContext";

const MainProvider = ({ children }) => {
  return (
    <LoaderProvider>
      <CartProvider>
        <AuthProvider>
          <GraffitiProvider>
            <CouponProvider>
            <WalletProvider>{children}</WalletProvider>
          </CouponProvider>
          </GraffitiProvider>
        </AuthProvider>
      </CartProvider>
    </LoaderProvider>
  );
};

export default MainProvider;
